export const SHOPPING_BAG_MERGING_POPUP = "shopping-bag-merging-popup";
export const PRODUCT_CARD_INDEX = "product_card_index";
export const PREVIOUS_PATH = "previousPath";
export const PREVIOUS_CURRENT_LOCALES = "previousCurrentLocales";
export const CHECKOUT_SIGN_IN = "checkoutSignIn";
export const CROSS_SELL_PRODUCT_CLICK = "crossSellProductClick";
export const LAST_STORE_SEARCH = "lastStoreSearch";
export const STORES_FROM_SEARCH_FIELD = "storesFromSearchField";
export const DY_USER_ACTIVE_CONSENT = "userActiveConsent";

export enum SHOPPING_BAG_MERGING_POPUP_TYPE {
  ANONYMOUS = "anonymous",
  ABANDONED = "abandoned",
}
